import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Card from "antd/lib/card";
import Button from "antd/lib/button";
import Input from "antd/lib/input";
import Layout from "antd/lib/layout";
import message from 'antd/lib/message';
import UserOutlined from "@ant-design/icons/UserOutlined";
import { useFirestore } from 'reactfire';
import { collection, addDoc } from 'firebase/firestore';

const { TextArea } = Input;
const { Content, Footer } = Layout;
const Support = () => {
    const db = useFirestore();
    const submit = async (event) => {
      event.preventDefault();
      setLoading(true)
      const { email, issue } = support;
      await addDoc(collection(db, "support"), {email, issue});
      message.success("Nuestro equipo de soporte se pondra en concatco contigo en los proximos dias")
      setSupport({ email: "", issue: "" });
      setLoading(false)
    }
  // state
  const [support, setSupport] = React.useState({ email: "", issue: "" });
  const [loading, setLoading] = React.useState(false)
  const { email, issue } = support;

  const handleUpdate = (event) => {
      setSupport({
          ...support,
          [event.currentTarget.name]: event.currentTarget.value,
      })
  }


    return (
        <StyledLayout className="layout">
          <StyledContent style={{ padding: "0 50px" }}>
            <div className="site-layout-content">
              <Card className="card">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/logo.png"
                    alt="E-VIA Logo"
                    style={{ width: "auto", height: "20vh" }}
                  ></img>
                </div>
                <form onSubmit={(event) => submit(event)}>
                  <Input
                    className="input"
                    size="large"
                    name="email"
                    placeholder="Correo"
                    value={email}
                    onChange={handleUpdate}
                    prefix={<UserOutlined />}
                  />
                  <TextArea className='input' value={issue} onChange={handleUpdate} name="issue" rows={6} placeholder='Con que te podemos ayudar?' />
                  <Button loading={loading} className="input" htmlType="submit" type="primary" block>
                    Crear ticket de soporte
                  </Button>
                </form>
                <Link to="/sign-in">
                  <Button className="input" type="link" block>
                    Volver a inicio de sesión
                  </Button>
                </Link>
              </Card>
            </div>
          </StyledContent>
          <Footer style={{ textAlign: "center" }}>
            Copyright © 2023-2024. Todos los derechos reservados.
          </Footer>
        </StyledLayout>
      )
}

export default Support

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  display: flex;
`;


const StyledContent = styled(Content)`
  display: flex;
  justify-content: center;
  align-items: center;

  .input {
    margin: 8px;
  }
`;
